var EquipmentSearch = function () {

    var comp = $('[data-component="equipment-search"]');

    this.init = function () {

        this.equipmentSearch();

    }

    this.equipmentSearch = function () {

        $('.find').on('click', function() {
            $(this).parents(comp).find('.search-holder').slideToggle(300);
        });
    }

    return this.init();

}
